import React, { createContext } from "react";
import io from "socket.io-client";

import ENDPOINTS from "../services/endpoints";

export const socket = io.connect(ENDPOINTS.SOCKET.CONNECT_NOTE_SOCKET);
export const SocketContext = createContext();
